<div class="row pt-2 pb-2 bg-white">
  <div class="col-12">

    <!-- Title -->
    <div class="row pb-2 border-bottom">
      <div class="col-6">
       <span class="text-muted fw-bold">Products ({{ productsSelected.length }})</span>
      </div>
      <div class="col-6">
        <div class="input-group">
          <input class="form-control form-control-sm" type="text" placeholder="Search by product name" id="search-input" [(ngModel)]="searchText" (keyup.enter)="onSearchEnter($event)" onsearch="getProducts()">
          <div class="input-group-append">
            <button class="btn btn-sm btn-outline-secondary mr-3" type="submit" (click)="clearSearch()" *ngIf="searchText">
              <i-bs class="search-close text-dark" name="x"></i-bs>
            </button>

            <button class="btn btn-sm btn-secondary" type="submit" (click)="searchProduct()" [disabled]="!searchText">
              <!--<i class="fa fa-search fa-1x text-light" aria-hidden="true"></i>-->
              <i-bs class="search-close text-dark" name="search"></i-bs>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Prducts List -->
    <div class="row">
      <div class="col-12">
        <!-- Loader & Empty message -->
        <div class="row">
          <div class="col-12 text-center">
            <div class="spinner-border text-info mt-4" role="status" *ngIf="productsLoading === true"></div>

            <div class="col-12 text-center text-danger mt-4" *ngIf="productsLoading === false && products.length == 0">Products not found</div>
          </div>
        </div>

        <!-- Prducts -->
        <div *ngIf="productsLoading === false && products.length > 0">
          <!-- Header -->
          <div class="row grid-row border-bottom mt-2">
            <div class="col-1 col-md-1 grid-title"></div>
            <div class="col-2 col-md-3 grid-title">UPC</div>
            <div class="col-6 col-md-5 grid-title">Name</div>
            <div class="col-3 col-md-3 grid-title">Brand</div>
          </div>
        </div>

        <div class="row grid-row border-bottom border-light mt-2" *ngFor="let product of products | paginate: { itemsPerPage: 10, currentPage: productsPage, totalItems: productsCount }">
          <div class="col-1 col-md-1 grid-item">
            <div class="form-check form-switch" (change)="onProductClick(product, $event)">
              <input type="checkbox" class="form-check-input" [id]="product.upc" [checked]="isProductSelected(product)">
              <label class="form-check-label" [for]="product.upc"></label>
            </div>
          </div>
          <div class="col-2 col-md-3 grid-item">{{ product.upc }}</div>
          <div class="col-6 col-md-5 grid-item">{{ product.product_name }}</div>
          <div class="col-3 col-md-3 grid-item">{{ product.brand_name }}</div>
        </div>
      </div>

    </div>

    <!-- Next Button -->
    <div class="row mt-3 pt-3 mb-0 border-top">
      <div class="col-6">
        <pagination-controls class="pagination-style" maxSize="4" previousLabel="" nextLabel="" autoHide="true" (pageChange)="onPageChange($event)"></pagination-controls>
      </div>
      <div class="col-6">
        <button type="button" class="btn btn-secondary text-white fw-bold float-end" title="Build Coupon" (click)="onNavigationClick('next')">
          <i-bs class="text-light" name="arrowRight" width="22" height="22"></i-bs>
        </button>
      </div>
    </div>

  </div>
</div>
